// Copyright (c) 2015-present RIT.

export const required = (value) => value ? undefined : `Обязательно`;

export const maxLength = (max) => (value) => (value && value.length > max ? `Макисмальное кол-во символов: ${max}` : undefined);

export const minLength = (min) => (val) => {
    return (val && val.length <= min ? `Макисмальное кол-во символов ${min}` : undefined);
};

export const minValue = (min, name) => (value) => {
    return (value && Number(value) <= min ? `${name} должен составлять минимум ${min} см` : undefined);
};

export const maxValue = (max, name) => (value) => {
    return (value && Number(value) >= max ? `${name} не должен превышать ${max} см` : undefined);
};

export const betweenValue = (min, max) => (value) => {
    const numberValue = Number(value);
    return ((numberValue < min || numberValue > max)) ? `*от ${min} до ${max} см` : null;
}

export const number = (value) => value && isNaN(Number(value)) ? 'Некорректное значение' : undefined;

export const positive = (value) => (
    value && (parseFloat(value) < 0) ? 'Значение должно быть больше 0' : undefined);

export const email = (value) => (value && !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i).test(value) ? 'Введен некорректный e-mail' : undefined);

export const tooOld = (value) => (value && value > 65 ? 'You might be too old for this' : undefined);